export default function NoAppointmentCard() {
  return (
    <div className="space-y-2 rounded-sm border border-rose-500 bg-rose-50 px-4 py-3">
      <h3 className="text-md font-medium">No Appointment</h3>

      <p>
        There was an error in scheduling your appointment, but we have all your details and will
        reach out shortly!
      </p>
    </div>
  );
}
